import { render, staticRenderFns } from "./tags-home.vue?vue&type=template&id=0a06531d&scoped=true&"
import script from "./tags-home.vue?vue&type=script&lang=ts&"
export * from "./tags-home.vue?vue&type=script&lang=ts&"
import style0 from "./tags-home.vue?vue&type=style&index=0&id=0a06531d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06531d",
  null
  
)

export default component.exports